import { pilots } from './pilots'
import { gauntlets } from './gauntlets'
import { academy } from './academy'

export const contents = [
    pilots,
    gauntlets,
    academy
]